import { ChevronRight } from "lucide-react";
import { SHIFT_STEPS } from "@/lib/yasamaru";

export function Stepper({ step, onChange, magicDone }) {
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-1 flex overflow-x-auto" data-testid="step-nav">
      {SHIFT_STEPS.map((s, idx) => {
        const isActive = step === s.id;
        const isDone = step > s.id;
        const isLocked = !magicDone && s.id >= 3;
        return (
          <button
            key={s.id} type="button" data-testid={`step-${s.id}`}
            onClick={() => !isLocked && onChange(s.id)}
            disabled={isLocked}
            title={isLocked ? "配置マジックを1度実行してから進めます" : ""}
            className={`flex items-center gap-1.5 whitespace-nowrap px-4 py-2 rounded-md text-sm font-semibold transition-colors ${
              isActive ? "bg-blue-600 text-white" :
              isDone ? "text-emerald-700 hover:bg-emerald-50" :
              isLocked ? "text-slate-300 cursor-not-allowed" :
              "text-slate-500 hover:bg-slate-50"
            }`}
          >
            <span className={`inline-flex w-5 h-5 items-center justify-center rounded-full text-[11px] ${
              isActive ? "bg-white/20 text-white" :
              isDone ? "bg-emerald-100 text-emerald-700" :
              isLocked ? "bg-slate-100 text-slate-300" :
              "bg-slate-100 text-slate-500"
            }`}>{isDone ? "✓" : isLocked ? "🔒" : s.id}</span>
            <span>{s.label}</span>
            {idx < SHIFT_STEPS.length - 1 && <ChevronRight className="w-3 h-3 opacity-40" />}
          </button>
        );
      })}
    </div>
  );
}
